import { render } from "./AmountInput.vue?vue&type=template&id=cdc07870&scoped=true"
import script from "./AmountInput.vue?vue&type=script&lang=js"
export * from "./AmountInput.vue?vue&type=script&lang=js"

import "./AmountInput.vue?vue&type=style&index=0&id=cdc07870&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdc07870"]])

export default __exports__